import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { GlobalContext } from '../contexts/GlobalContext';

const useStyles = makeStyles({
	root: {
		minWidth: 205,
		borderRadius: 12,
		textAlign: 'center',
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)',
	},
	title: {
		fontSize: 18,
		fontWeight: 700,
		marginBottom: 0,
	},
	topContent: {
		padding: '8px',
		backgroundColor: '#dfe2e8',
	},
	pos: {
		marginBottom: 12,
	},
	boxCount: {
		borderRight: '1px solid rgba(0, 0, 0, 0.08)',
	},
	statLabel: {
		fontSize: 18,
		marginBottom: 4,
		fontWeight: 500,
		fontFamily:
			'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
		margin: 0,
	},
	statValue: {
		fontSize: 20,
		fontWeight: 'bold',
		marginBottom: 4,
		letterSpacing: '1px',
	},
});

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const RefSetsCard = (props) => {
	const [activeCount, setActiveCount] = useState(0);
	const gc = useContext(GlobalContext);

	const { refsets, refsetsLoaded } = gc;

	const classes = useStyles();

	useEffect(() => {
		if (refsetsLoaded) {
			setActiveCount(refsets.expansion.contains.length);
		}
	}, [refsets, refsetsLoaded]);

	return (
		<Card variant="outlined" className={classes.root}>
			<CardContent className={classes.topContent}>
				<Typography
					className={classes.title}
					color="textSecondary"
					gutterBottom
				>
					SNOMED RefSets
				</Typography>
			</CardContent>
			{/* <Card variant="outlined" className={classes.root}> */}
			<Divider light />
			<Box display={'flex'}>
				<Box p={2} flex={'1'} className={classes.boxCount}>
					<p className={classes.statLabel}>Active</p>
					<p className={classes.statValue}>{numberWithCommas(activeCount)}</p>
				</Box>
				<Divider light />
			</Box>
		</Card>
	);
};

export default RefSetsCard;
